import React, { Suspense as ReactSuspense } from 'react';
import type { IProps } from './types';
import GradientLoader from '../../design-system/components/atoms/custom-spinner/gradient-loader';

const Suspense: React.FC<IProps> = ({ children }) => (
  <ReactSuspense fallback={<GradientLoader />}> {children} </ReactSuspense>
);

export default Suspense;
